import React from 'react';
import RichTextEditor from '../../components/common/RichTextEditor';
import { marked } from 'marked';

export default function ExplanationEditor({ value, onChange }) {
  // 마크다운을 HTML로 변환하여 에디터에 전달
  const convertMarkdownToHtml = (markdown) => {
    if (!markdown) return '';
    try {
      return marked(markdown);
    } catch (error) {
      console.error('마크다운 변환 오류:', error);
      return markdown; // 변환 실패 시 원본 반환
    }
  };

  // HTML을 마크다운으로 변환 (간단한 변환)
  const convertHtmlToMarkdown = (html) => {
    if (!html) return '';
    
    // 기본적인 HTML → 마크다운 변환
    return html
      // 테이블 변환
      .replace(/<table[^>]*>/g, '')
      .replace(/<\/table>/g, '\n')
      .replace(/<thead[^>]*>/g, '')
      .replace(/<\/thead>/g, '')
      .replace(/<tbody[^>]*>/g, '')
      .replace(/<\/tbody>/g, '')
      .replace(/<tr[^>]*>/g, '')
      .replace(/<\/tr>/g, '\n')
      .replace(/<th[^>]*>/g, '| ')
      .replace(/<\/th>/g, ' ')
      .replace(/<td[^>]*>/g, '| ')
      .replace(/<\/td>/g, ' ')
      // 헤딩 변환
      .replace(/<h1[^>]*>(.*?)<\/h1>/g, '# $1\n')
      .replace(/<h2[^>]*>(.*?)<\/h2>/g, '## $1\n')
      .replace(/<h3[^>]*>(.*?)<\/h3>/g, '### $1\n')
      // 강조 변환
      .replace(/<strong[^>]*>(.*?)<\/strong>/g, '**$1**')
      .replace(/<b[^>]*>(.*?)<\/b>/g, '**$1**')
      .replace(/<em[^>]*>(.*?)<\/em>/g, '*$1*')
      .replace(/<i[^>]*>(.*?)<\/i>/g, '*$1*')
      // 링크 변환
      .replace(/<a[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/g, '[$2]($1)')
      // 이미지 변환
      .replace(/<img[^>]*src="([^"]*)"[^>]*alt="([^"]*)"[^>]*>/g, '![$2]($1)')
      .replace(/<img[^>]*src="([^"]*)"[^>]*>/g, '![]($1)')
      // 리스트 변환
      .replace(/<ul[^>]*>/g, '')
      .replace(/<\/ul>/g, '\n')
      .replace(/<ol[^>]*>/g, '')
      .replace(/<\/ol>/g, '\n')
      .replace(/<li[^>]*>/g, '- ')
      .replace(/<\/li>/g, '\n')
      // 코드 변환
      .replace(/<code[^>]*>(.*?)<\/code>/g, '`$1`')
      .replace(/<pre[^>]*><code[^>]*>(.*?)<\/code><\/pre>/gs, '```\n$1\n```')
      // 인용 변환
      .replace(/<blockquote[^>]*>(.*?)<\/blockquote>/gs, '> $1')
      // 줄바꿈 변환
      .replace(/<br\s*\/?>/g, '\n')
      .replace(/<\/p><p[^>]*>/g, '\n\n')
      .replace(/<p[^>]*>/g, '')
      .replace(/<\/p>/g, '\n')
      // HTML 태그 제거
      .replace(/<[^>]*>/g, '')
      // 연속된 줄바꿈 정리
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  };

  const handleChange = (htmlContent) => {
    // HTML을 마크다운으로 변환하여 저장
    const markdown = convertHtmlToMarkdown(htmlContent);
    onChange(markdown);
  };

  // 초기값을 HTML로 변환
  const initialHtmlValue = convertMarkdownToHtml(value);

  return (
    <RichTextEditor
      value={initialHtmlValue}
      onChange={handleChange}
      placeholder="해설을 입력하세요..."
      minHeight={400}
    />
  );
}
